<template>
    <div class="navbar">
        <v-toolbar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                color="blue darken-3"
                dark
                app
                fixed
        >

            <!--<v-toolbar-title v-if="user" style="width: 300px" class="ml-0 pl-3">-->
                <!--<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>-->
            <!--</v-toolbar-title>-->

            <v-spacer></v-spacer>

            <router-link class="v-btn" :to="{ name: 'Home'}">Home</router-link>
            <router-link v-if="!user" class="v-btn" :to="{ name: 'Signup'}">Signup</router-link>
            <router-link v-if="!user" class="v-btn" :to="{ name: 'Login'}">Login</router-link>
            <v-btn v-if="user" class="blue darken-3" @click.prevent="logout">Logout</v-btn>
        </v-toolbar>

    </div>
</template>

<script>
    import firebase from 'firebase'
    export default {
        name: "Navbar",
        data() {
            return {
                title: "Data Chester Inc.",
                user: null
            }
        },
        methods: {
            logout() {
                firebase.auth().signOut().then(
                    () => this.$router.push({name: 'Home'})
                )
            }
        },
       created(){
           firebase.auth().onAuthStateChanged((user) => {
               if(user){
                   this.user = user
               }else{
                   this.user = null
               }
           })
       }
    }
</script>

<style scoped>
a{
    text-decoration: none;
    color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Navbar.vue